import React from "react";
import { Link } from "react-router-dom";

const cities = [
    { name: "London", slug: "london", country_slug: "united-kingdom" },
    { name: "Manchester", slug: "manchester", country_slug: "united-kingdom" },
    { name: "New York", slug: "new-york", country_slug: "united-states" },
    { name: "Sydney", slug: "sydney", country_slug: "australia" },
    { name: "Dubai", slug: "dubai", country_slug: "united-arab-emirates" },
    { name: "Toronto", slug: "toronto", country_slug: "canada" },
];

const eventTypes = [
    { label: "Birthday parties", slug: "birthday-parties" },
    { label: "Corporate events", slug: "corporate-events" },
    { label: "Weddings", slug: "weddings" },
    { label: "Private dining", slug: "private-dining" },
    { label: "Christmas parties", slug: "christmas-parties" },
];

export default function Footer() {
    return (
        <footer className="mt-24 border-t border-border bg-muted/30" data-testid="site-footer">
            <div className="container-app py-12 md:py-16 grid md:grid-cols-4 gap-10">
                <div>
                    <div className="flex items-center gap-2 mb-4">
                        <div className="h-9 w-9 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-display font-bold">V</div>
                        <span className="font-display text-xl">Venuely</span>
                    </div>
                    <p className="text-sm text-muted-foreground max-w-xs">Find and enquire about private venues for hire anywhere in the world.</p>
                </div>
                <div>
                    <h4 className="font-display text-base mb-4">Popular cities</h4>
                    <ul className="space-y-2">
                        {cities.map((c) => (
                            <li key={c.slug}>
                                <Link
                                    to={`/venues/${c.country_slug}/${c.slug}`}
                                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                                    data-testid={`footer-city-${c.slug}`}
                                >
                                    Venues in {c.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div>
                    <h4 className="font-display text-base mb-4">By event type</h4>
                    <ul className="space-y-2">
                        {eventTypes.map((e) => (
                            <li key={e.slug}>
                                <Link
                                    to={`/events/${e.slug}/london`}
                                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                                >
                                    {e.label} in London
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div>
                    <h4 className="font-display text-base mb-4">Company</h4>
                    <ul className="space-y-2 text-sm text-muted-foreground">
                        <li><Link to="/about" className="hover:text-foreground">About</Link></li>
                        <li><Link to="/how-it-works" className="hover:text-foreground">How it works</Link></li>
                        <li><Link to="/pricing" className="hover:text-foreground">Pricing</Link></li>
                        <li><Link to="/list-your-venue" className="hover:text-foreground">List your venue</Link></li>
                        <li><Link to="/contact" className="hover:text-foreground">Contact</Link></li>
                        <li><Link to="/terms" className="hover:text-foreground">Terms</Link></li>
                        <li><Link to="/privacy" className="hover:text-foreground">Privacy</Link></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-border">
                <div className="container-app py-6 text-xs text-muted-foreground flex flex-col md:flex-row items-center justify-between gap-2">
                    <span>© {new Date().getFullYear()} Venuely. All rights reserved.</span>
                    <span>Made for people planning great events.</span>
                </div>
            </div>
        </footer>
    );
}
